import { GlobalResponseObject } from "../../common";
import { QuestionBankModel } from "./question-bank.model";

export class QuestionBankResponse extends GlobalResponseObject {
    data: QuestionBankModel[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data: QuestionBankModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}